import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.importFileDropZone';

export default defineMessages({
  dragAndDropUploadMessage: {
    id: `${scope}.dragAndDropUploadMessage`,
    defaultMessage: 'Drag and drop your file here',
  },
  or: {
    id: `${scope}.or`,
    defaultMessage: 'or',
  },
  browseFile: {
    id: `${scope}.browseFile`,
    defaultMessage: 'Browse',
  },
  wrongFileFormat: {
    id: `${scope}.wrongFileFormat`,
    defaultMessage: 'Please choose .xlsx or .csv file format',
  },
  importFailed: {
    id: `${scope}.importFailed`,
    defaultMessage: 'Your import failed with errors',
  },
});
